/* FEEL B2B motion.

   Reveals blocks as they arrive and counts numbers up when they do.

   THE ONLY RULE THAT MATTERS HERE: the page must never be left invisible.
   The effect works by hiding things first, so every path that hides needs a
   path that shows, and none of them may depend on a single mechanism.

   Both of the obvious mechanisms can be dead at once. IntersectionObserver
   callbacks are not delivered in a tab that is not painting, the same way
   requestAnimationFrame is suspended there. Scroll events can be absent too,
   in embedded and emulated views. Either on its own will happily leave a
   whole page at opacity zero, which on a page sent to trade contacts is the
   worst outcome available.

   So there are four ways in, cheapest first:
     1. anything already on screen is revealed by MEASURING its rect, rather
        than by waiting to be told about it
     2. the observer, for everything else
     3. scroll and resize listeners, which re-measure
     4. a polling sweep that needs no events at all, and stops itself as soon
        as the last block has revealed
   And underneath all of it, a four second check: if nothing whatsoever has
   revealed by then, the effect is broken on this device, so the hiding class
   comes off and the page is simply static. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.FC_B2B_READY = true;

  function giveUp() { root.classList.remove('fc-anim'); }

  if (reduce || !('IntersectionObserver' in window)) { giveUp(); return; }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      reveal(entries[i].target);
      io.unobserve(entries[i].target);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function reveal(el) {
    el.classList.add('is-in');
    if (el.hasAttribute('data-count')) count(el);
    var inner = el.querySelectorAll('[data-count]');
    for (var i = 0; i < inner.length; i++) count(inner[i]);
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || root.clientHeight;
    return r.top < h && r.bottom > 0;
  }

  function pending() { return document.querySelectorAll('[data-reveal]:not(.is-in)'); }

  function sweep() {
    var els = pending();
    for (var i = 0; i < els.length; i++) {
      if (onScreen(els[i])) { reveal(els[i]); io.unobserve(els[i]); }
      else io.observe(els[i]);
    }
    return els.length;
  }

  /* Counts to data-count, keeping the prefix and suffix the markup shows, so
     the euro sign and the tilde survive. If rAF is suspended the text simply
     stays as Liquid rendered it, which is already the right number. */
  function count(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var target = parseFloat(el.dataset.count);
    if (isNaN(target)) return;
    var pre = el.dataset.prefix || '';
    var suf = el.dataset.suffix || '';
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var p = Math.min(1, (now - start) / 1100);
      el.textContent = pre + Math.round(target * (1 - Math.pow(1 - p, 3))) + suf;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = pre + target + suf;
    }
    requestAnimationFrame(frame);
  }

  var timer = null;
  function poll() {
    if (document.hidden) return;
    if (sweep() === 0 && timer) { clearInterval(timer); timer = null; }
  }

  function start() {
    sweep();
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
    timer = setInterval(poll, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', sweep);
  document.addEventListener('shopify:section:load', sweep);

  setTimeout(function () {
    if (!document.querySelector('[data-reveal].is-in')) giveUp();
  }, 4000);
})();